import { render } from "./tenantFrameWorks.vue?vue&type=template&id=4a0834e5&scoped=true&ts=true"
import script from "./tenantFrameWorks.vue?vue&type=script&lang=ts"
export * from "./tenantFrameWorks.vue?vue&type=script&lang=ts"

import "./tenantFrameWorks.vue?vue&type=style&index=0&id=4a0834e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0834e5"]])

export default __exports__